/*
THIS COMPONENT INCLUDING IN EMAIL PATTERN PAGE
 ---------------------------------------------*/
let SendTestMail = (() => {
    const $emailInput = '.email-input';
    const $sendButton = '.send-test-mail';
    const $alertContainer = '#send-test-mail-alert';
    const $emailPattern = '.email-pattern-id';
    const $adminPanel = '.domain-panel';

    let init = () => {
        $($sendButton).click(function() {
            showLoader();
            const emailPatternId = $(this).closest($adminPanel).find($emailPattern).val();
            $.post(`/settings/email_patterns/${emailPatternId}/send_test`, {
                email: $(this).closest($adminPanel).find($emailInput).val(),
                domain: $(this).closest($adminPanel).data('domain')
            }).then( (response) => {
                response.success
                    ? showSuccess(response.success)
                    : showError(response.error);

                hideLoader();
            });
        });
    };

    let showLoader = () => {
        $($sendButton).find('i').show();
        $($sendButton).find('span').hide();
    };

    let hideLoader = () => {
        $($sendButton).find('i').hide();
        $($sendButton).find('span').show();
    };

    let showSuccess = (message) => {
        $($emailInput).val('');
        $($alertContainer).text(message);
        $($alertContainer).removeClass('alert-danger');
        $($alertContainer).addClass('alert-success');
        $($alertContainer).removeClass('hidden');
    };

    let showError = (message) => {
        $($emailInput).val('');
        $($alertContainer).text(message);
        $($alertContainer).removeClass('alert-success');
        $($alertContainer).addClass('alert-danger');
        $($alertContainer).removeClass('hidden');
    };

    return {
        init: init
    }
})();

export default SendTestMail;
